import { URLS } from '@wix/da-url';
import { BackgroundType, BackgroundImageDisplayMode, } from './types';
export var TEMPLATES = [
    {
        title: 'Empty Canvas',
        subtitle: 'Start from Scratch',
        previewImage: "".concat(URLS.CDN, "/eclipse/widgets/custombox/template_1.thumb.png"),
        backgroundImage: '',
        moduleData: {
            color: '',
            gradient: 0,
            imageTint: 'rgba(28,28,61,0.19)',
            imageDisplayMode: BackgroundImageDisplayMode.TILE,
            backgroundType: BackgroundType.TEMPLATE_1,
        },
    },
    {
        title: 'Dawn Grid',
        subtitle: 'Commission List',
        previewImage: "".concat(URLS.CDN, "/eclipse/widgets/custombox/template_2.thumb.png"),
        backgroundImage: "".concat(URLS.CDN, "/eclipse/widgets/custombox/template_2.jpg"),
        moduleData: {
            backgroundType: BackgroundType.TEMPLATE_2,
            color: '',
            gradient: 0,
            imageDisplayMode: BackgroundImageDisplayMode.COVER,
            imageTint: 'rgba(6,7,13,0)',
        },
    },
    {
        title: 'Funky Fronds',
        subtitle: 'Introduction',
        previewImage: "".concat(URLS.CDN, "/eclipse/widgets/custombox/template_3.thumb.png"),
        backgroundImage: "".concat(URLS.CDN, "/eclipse/widgets/custombox/template_3.jpg"),
        moduleData: {
            backgroundType: BackgroundType.TEMPLATE_3,
            color: '',
            gradient: 0,
            imageDisplayMode: BackgroundImageDisplayMode.COVER,
            imageTint: 'rgba(6,7,13,0.27)',
        },
    },
    {
        title: 'Floral Breeze',
        subtitle: 'Introduction',
        previewImage: "".concat(URLS.CDN, "/eclipse/widgets/custombox/template_4.thumb.png"),
        backgroundImage: "".concat(URLS.CDN, "/eclipse/widgets/custombox/template_4.gif"),
        moduleData: {
            backgroundType: BackgroundType.TEMPLATE_4,
            color: '',
            gradient: 0,
            imageDisplayMode: BackgroundImageDisplayMode.COVER,
            imageTint: 'rgba(6,7,13,0)',
        },
    },
    {
        title: 'Marbleized',
        subtitle: 'Moodboard',
        previewImage: "".concat(URLS.CDN, "/eclipse/widgets/custombox/template_5.thumb.png"),
        backgroundImage: "".concat(URLS.CDN, "/eclipse/widgets/custombox/template_5.jpg"),
        moduleData: {
            backgroundType: BackgroundType.TEMPLATE_5,
            color: '#F2F4E8',
            gradient: 0,
            imageDisplayMode: BackgroundImageDisplayMode.COVER,
            imageTint: 'rgba(247,247,233,0)',
        },
    },
    {
        title: 'Pixel Perfect',
        subtitle: 'Commission List',
        previewImage: "".concat(URLS.CDN, "/eclipse/widgets/custombox/template_6.thumb.png"),
        backgroundImage: "".concat(URLS.CDN, "/eclipse/widgets/custombox/template_6.png"),
        moduleData: {
            backgroundType: BackgroundType.TEMPLATE_6,
            color: '#F8F2F8',
            gradient: 0,
            imageDisplayMode: BackgroundImageDisplayMode.TILE,
            imageTint: 'rgba(255,255,255,0)',
            pattern: "".concat(URLS.CDN, "/misc/custombox/patterns/pink-diamonds.png"),
        },
    },
    {
        title: 'Stellar',
        subtitle: 'Introduction',
        previewImage: "".concat(URLS.CDN, "/eclipse/widgets/custombox/template_7.thumb.png"),
        backgroundImage: "".concat(URLS.CDN, "/eclipse/widgets/custombox/template_7.png"),
        moduleData: {
            backgroundType: BackgroundType.TEMPLATE_7,
            color: '',
            gradient: 0,
            imageDisplayMode: BackgroundImageDisplayMode.COVER,
            imageTint: 'rgba(6,7,13,0)',
        },
    },
    {
        title: 'Pastel Whimsy',
        subtitle: 'Commission List',
        previewImage: "".concat(URLS.CDN, "/eclipse/widgets/custombox/template_8.thumb.png"),
        backgroundImage: "".concat(URLS.CDN, "/eclipse/widgets/custombox/template_8.png"),
        moduleData: {
            backgroundType: BackgroundType.TEMPLATE_8,
            color: '',
            gradient: 0,
            imageDisplayMode: BackgroundImageDisplayMode.COVER,
            imageTint: 'rgba(222,129,104,0.49)',
        },
    },
    {
        title: 'Twinkle',
        subtitle: 'Moodboard',
        previewImage: "".concat(URLS.CDN, "/eclipse/widgets/custombox/template_9.thumb.png"),
        backgroundImage: "".concat(URLS.CDN, "/eclipse/widgets/custombox/template_9.gif"),
        moduleData: {
            backgroundType: BackgroundType.TEMPLATE_9,
            color: '',
            gradient: 0,
            imageDisplayMode: BackgroundImageDisplayMode.TILE,
            imageTint: 'rgba(6,7,13,0)',
        },
    },
    {
        title: 'Autumn Mist',
        subtitle: 'Literature',
        previewImage: "".concat(URLS.CDN, "/eclipse/widgets/custombox/template_10.thumb.png"),
        backgroundImage: "".concat(URLS.CDN, "/eclipse/widgets/custombox/template_10.jpg"),
        moduleData: {
            backgroundType: BackgroundType.TEMPLATE_10,
            color: '',
            gradient: 0,
            imageDisplayMode: BackgroundImageDisplayMode.COVER,
            imageTint: 'rgba(229,229,223,0.86)',
        },
    },
    {
        title: 'Gatsby Deco',
        subtitle: 'Introduction',
        previewImage: "".concat(URLS.CDN, "/eclipse/widgets/custombox/template_11.thumb.png"),
        backgroundImage: "".concat(URLS.CDN, "/eclipse/widgets/custombox/template_11.png"),
        moduleData: {
            backgroundType: BackgroundType.TEMPLATE_11,
            color: '',
            gradient: 0,
            imageDisplayMode: BackgroundImageDisplayMode.TILE,
            imageTint: 'rgba(1,6,38,0)',
        },
    },
];
//# sourceMappingURL=templates.js.map